import * as React from 'react';
import cx from 'classnames';
import styles from './PincodeInputWidget.css';
import { isValidPincode } from 'utils/validators';
import LoctionButton from './LocationButton';
import { maxlength } from 'utils/validators';
import { stringTemplate } from 'components/StringWidget/StringWidget';
function isDigitsOnly(value = '') {
    const DIGITS_ONLY_REGEXP = /^\d*$/;
    return DIGITS_ONLY_REGEXP.test(value);
}
const handlePincodeSubmit = (props, pincode) => (e) => {
    e.preventDefault();
    const valid = isValidPincode(pincode);
    props.onPincodeSubmit(pincode, valid);
};
const handlePincodeInputChanged = (props) => (e) => {
    if (e.target instanceof HTMLInputElement) {
        const pincode = e.target.value || '';
        if (isDigitsOnly(pincode) && maxlength(pincode, 6)) {
            const valid = isValidPincode(pincode);
            props.onPincodeInputChanged(pincode, valid);
        }
    }
};
const handleOnFocus = (e) => {
    const inputElement = e.currentTarget;
    if (typeof inputElement.selectionStart === 'number') {
        inputElement.selectionStart = inputElement.selectionEnd = inputElement.value.length;
    }
};
const handleLocationReceivied = (props) => (pincode) => {
    const valid = isValidPincode(pincode);
    props.onPincodeSubmit(pincode, valid);
};
export default function PincodeInputwidget(props) {
    const { marketPlacePincode, pincodeText, onLocatingStarted, error } = props;
    const { popupMessage, widgetTitle } = marketPlacePincode;
    return (<React.Fragment>
			<div className={styles['title']}> {widgetTitle} </div>
			{popupMessage && <div className={styles['popup-msg']}>{popupMessage}</div>}
			<form className={cx(styles['pincode-text-container'], { [styles['error']]: error })} onSubmit={handlePincodeSubmit(props, pincodeText)}>
				<input onFocus={handleOnFocus} value={pincodeText || ''} onChange={handlePincodeInputChanged(props)} className={styles['pincode-input']} type="text" title={stringTemplate('enterPincodeTooltip')} name="pincode" autoComplete="off" maxLength={6} placeholder={stringTemplate('enterPincodeTooltip')} autoFocus/>
				<LoctionButton onLocationReceived={handleLocationReceivied(props)} onLocatingStarted={onLocatingStarted}/>
			</form>
		</React.Fragment>);
}
